/**
 * @file testimonials.ts
 * @path apps/website/src/data/testimonials.ts
 * @description
 */

import { Testimonial } from "@sirbastians/types";

export const testimonialsData: Testimonial[] = [
  {
    rating: 5,
    quote:
      "Professional, punctual, safe and efficient. My son is using the shuttle to tech and back home and he is extremely happy with the experience. My only regret is not finding out about it sooner!",
    author: "Naeema Ebrahim Jackson",
    company: "Student's Parent",
  },
  {
    rating: 5,
    quote:
      "Our driver Kyle was extremely nice on our 1-day trip across Cape Town and explained the history of the attractions. The service was kind, professional, and helped us experience the city so much better.",
    author: "Ariel Fox",
    company: "Tourist",
  },
  {
    rating: 5,
    quote:
      "Thanks for always delivering such amazing service! Always prompt, friendly and good rates!",
    author: "Andrea Van Rensburg",
    company: "Repeat Customer",
  },
  {
    rating: 5,
    quote:
      "I strongly recommend this exceptional shuttle service for all your trips. You will not be disappointed!",
    author: "Andrea Steenkamp",
    company: "Local Traveler",
  },
  {
    rating: 5,
    quote:
      "Thanks so much for transporting us to Eden on the Bay and back. We will definitely continue using your service!",
    author: "Estelle Fester",
    company: "Private Hire",
  },
  {
    rating: 5,
    quote:
      "Making my way to and from UWC has been so much more convenient with Sir Bastian's Shuttle Service. They have 3 arrival and departure times to choose from, always ensuring I get to campus on time.",
    author: "Liam Darues",
    company: "Student",
  },
];
